import axios from "axios";
import { ApiHost } from "../utils/ApiConfig";
import config from "../config";


import logger from "../utils/logger";
const debug = config.runmode.debug;

function generateGUID() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

function createEmptyStep1() {
  const step = {
    Data: {
      exportFromPoland: "",
      exportNotFromPoland: "",
      displayName: "",
      applicantNIP: "",
      applicantName: "",
      applicantStreet: "",
      applicantBuilding: "",
      applicantAppartment: "",
      applicantPostCode: "",
      applicantCity: "",
      applicantId: "",
      editExporterCertificateData: false,
      exporterCertificateData: "",
      signedIndependently: false,
      signedByProxy: false,
      signedByAgent: false,
      agentNIP: "",
      agentName: "",
      agentStreet: "",
      agentBuilding: "",
      agentAppartment: "",
      agentPostCode: "",
      agentCity: "",
      agentId: "",
      proxyFiles: [createEmptyFileData()],
      phoneNumber: "",
      exporterIsProducer: false,
      exporterIsNotProducer: false,
      transportDispatched: false,
      transportNotDispatched: false,
      IE599File: createEmptyFileData(),
    },
    Comments: [],
  };

  return step;
}

function createEmptyProductData() {
  const productData = {
    id: generateGUID(),
    productName: "",
    quantity: "",
    unit: "",
    quantityDesc: "",
    tariffCode: "",
    originCountry: "",
    producerName: "",
    producerCountry: "",
    producerStreet: "",
    producerBuilding: "",
    producerAppartment: "",
    producerPostCode: "",
    producerCity: "",
    producer: "",
    exporter: "",
    boughtInEU: "",
    boughtOutsideEU: "",
    importClearanceFile: createEmptyFileData(),
  };

  return productData;
}

function createEmptySummary() {
  const productsSummary = {
    totalQuantity: "",
    totalNetWeight: "",
    totalGrossWeight: "",
    countriesOfOrigin: "",
    transportDetails: "",
    productsRemarks: "",
    productsSummaryEdit: "",
    quantitySummaryEdit: "",
    editCountriesOfOrigin: "false",
    editSummaries: "false",
  };

  return productsSummary;
}

function createEmptyStep2() {
  const step = {
    Data: {
      Products: [createEmptyProductData()],
      Summary: createEmptySummary(),
    },
    Comments: [],
  };

  return step;
}

function createEmptyProductComponent() {
  const productComponent = {
    componentName: "",
    originCountry: "",
    tariffCode: "",
  };

  return productComponent;
}

function createEmptyProductDetails() {
  const productDetails = {
    id: generateGUID(),
    name: "",
    Components: [createEmptyProductComponent()],
  };

  return productDetails;
}

function createEmptyProcessData() {
  const processData = {
    id: generateGUID(),
    productionProcessDescription: "",
    processFiles: [createEmptyFileData()],
    Products: [],
  };

  return processData;
}

function createEmptyStep3() {
  const step = {
    Data: {
      receiverUnknown: false,
      unknownReceiverDescription: "TO ORDER",
      receiverName: "",
      receiverCountry: "",
      receiverAddress: "",
      Processes: [],
    },
    Comments: [],
  };

  return step;
}

function createEmptyFileData() {
  const fileData = {
    id: "",
    name: "",
    description: "",
  };

  return fileData;
}

function createEmptyFileConnection() {
  const connectionData = {
    productName: "",
  };

  return connectionData;
}

function createEmptyStep4() {
  const step = {
    Data: {
      exportInvoiceFiles: [createEmptyFileData()],
      exportInvoiceValue: "",
      exportInvoiceCurrency: "",
      goodsFiles: [createEmptyFileData()],
      goodsFilesConnections: [],
      otherGoodsFiles: [createEmptyFileData()],
      otherGoodsFilesConnections: [],
      productFiles: [createEmptyFileData()],
      productFilesConnections: [],
      paymentFiles: [createEmptyFileData()],
    },
    Comments: [],
  };

  return step;
}

function createEmptyStep5() {
  const step = {
    Data: {
      statements: [false, false, false, false, false, false, false],
      chamber: "",
      printYes: "",
      additionalPrints: "0",
      shippingMethod: "",
      ShippingAddress: {
        name: "",
        country: "",
        street: "",
        building: "",
        appartment: "",
        postCode: "",
        city: "",
        phoneNumber: "",
      },
      shippingInfo: "",
      shippingDateSent: "",
    },
    Comments: [],
  };

  return step;
}

function createEmptyApplication() {
  const app = {
    DisplayName: "",
    Step_1: createEmptyStep1(),
    Step_2: createEmptyStep2(),
    Step_3: createEmptyStep3(),
    Step_4: createEmptyStep4(),
    Step_5: createEmptyStep5(),
    SignedDate: "",
    SignedFileId: "",
    SignedFileName: "",
    Attachments: [createEmptyFileData()],
    PaymentDate: "",
    PaymentFileId: "",
    PaymentFileName: "",
    IssueDate: "",
  };

  return app;
}

const addApplication = async (userId, displayName, accessToken) => {
  try {
    if (debug) logger.log("Tworzenie nowego wniosku: " + displayName);
    const response = await axios.post(
      ApiHost + `/application/add`,
      {
        user_id: userId,
        display_name: displayName,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    if (response.status === 200) {
      let newId = response.data.id;
      if (debug) logger.log("Utworzono nowy wniosek [" + newId + "]");
      return newId;
    }
  } catch (error) {
    logger.error("Błąd podczas tworzenia nowego wniosku: ", error);
  }
};

const copyApplication = async (id, userId, displayName, accessToken) => {
  try {
    if (debug)
      logger.log("Kopiowanie wniosku [" + id + "] jako: " + displayName);
    const response = await axios.post(
      ApiHost + `/application/copy`,
      {
        id: id,
        user_id: userId,
        display_name: displayName,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    if (response.status === 200) {
      let newId = response.data.id;
      if (debug)
        logger.log("Skopiowano wniosek [" + id + "] jako [" + newId + "]");
      return newId;
    }
  } catch (error) {
    logger.error("Błąd podczas kopiowania wniosku: ", error);
  }
};

const deleteApplication = async (id, userId, accessToken) => {
  try {
    if (debug) logger.log("Usuwanie wniosku [" + id + "]");
    const response = await axios.post(
      ApiHost + `/application/delete`,
      {
        id: id,
        user_id: userId,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    if (response.status === 200) {
      let result = response.data;
      if (debug) logger.log("Usunięto wniosek [" + id + "]");
      return result;
    }
  } catch (error) {
    logger.error("Błąd podczas usuwania wniosku: ", error);
  }
};

const getApplicationContent = async (id, accessToken) => {
  if (id === "00000000-0000-0000-0000-000000000000") return null;
  try {
    if (debug) logger.log("Pobieranie danych wniosku [" + id + "]");
    const response = await axios.post(
      ApiHost + `/application/get`,
      {
        id: id,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    if (response.status === 200) {
      let content = response.data.Application;
      if (debug)
        logger.log(
          "Pobrano dane wniosku\n\n\n[" + JSON.stringify(content) + "]"
        );
      return content;
    }
  } catch (error) {
    logger.error("Błąd podczas pobierania danych wniosku: ", error);
  }
};

const getPreviousVersionContent = async (id, accessToken) => {
  if (id === "00000000-0000-0000-0000-000000000000") return null;
  try {
    if (debug)
      logger.log(
        "Pobieranie zawartości poprzedniej wersji wniosku [" + id + "]"
      );
    const response = await axios.post(
      ApiHost + `/application/get_previous_version`,
      {
        id: id,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    if (response.status === 200) {
      let content = response.data.Application;
      if (debug)
        logger.log(
          "Pobrano zawartość poprzedniej wersji wniosku\n\n\n[" +
            JSON.stringify(content) +
            "]"
        );
      return content;
    }

    if (response.status === 204) return null;

    return createEmptyApplication();
  } catch (error) {
    logger.error(
      "Błąd podczas pobierania zawartości poprzedniej wersji wniosku: ",
      error
    );
  }
};

const getApplicationMetadata = async (id, accessToken) => {
  if (id === "00000000-0000-0000-0000-000000000000") return null;
  try {
    if (debug) logger.log("Pobieranie metadanych wniosku [" + id + "]");
    const response = await axios.post(
      ApiHost + `/application/metadata`,
      {
        id: id,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    if (response.status === 200) {
      let result = response.data;
      if (debug) logger.log(JSON.stringify(result));
      return result;
    }
  } catch (error) {
    logger.error("Błąd podczas pobierania metadanych wniosku: ", error);
  }
};

const getSignedApplication = async (
  id,
  fileName = "wniosek_CO_oryginalny.pdf",
  accessToken
) => {
  if (id === "00000000-0000-0000-0000-000000000000") return null;
  try {
    if (debug) logger.log("Pobieranie podpisanego wniosku [" + id + "]");
    const response = await axios.get(
      ApiHost + `/certificate/signed_application/` + id + "/true",
      {
        responseType: "blob",
        headers: { Authorization: `Bearer ${accessToken}` },
      }
    );

    if (response.status === 200) {
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: "application/pdf" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      if (debug) logger.log("Pobrano podpisany wniosek");
    }
  } catch (error) {
    logger.error("Błąd podczas pobierania podpisanego wniosku: ", error);
  }
};

const getApplicationComment = async (
  applicationId,
  step,
  commentId,
  oldCommentId,
  accessToken
) => {
  if (applicationId === "00000000-0000-0000-0000-000000000000") return null;
  try {
    if (debug)
      logger.log("Pobieranie komentarza z wniosku [" + applicationId + "]");
    const response = await axios.post(
      ApiHost + `/application/get_comment`,
      {
        id: applicationId,
        step: step,
        comment_id: commentId,
        old_comment_id: oldCommentId,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    if (response.status === 200) {
      let content = response.data.Application;
      if (debug)
        logger.log("Pobrano dane komentarza\n" + JSON.stringify(content) + "");
      return content;
    }
  } catch (error) {
    logger.error("Błąd podczas pobierania komentarza wniosku: ", error);
  }
};

const getOpenCommentCounts = async (applicationId, accessToken) => {
  if (applicationId === "00000000-0000-0000-0000-000000000000") return [];
  try {
    const response = await axios.post(
      ApiHost + `/application/get_open_comment_counts`,
      {
        id: applicationId,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    if (response.status === 200) {
      let count = response.data.OpenCommentCounts;
      return count;
    }
    return [];
  } catch (error) {
    logger.error(
      "Błąd podczas pobierania ilości otwartych komentarzy dla wniosku: ",
      error
    );
  }
};

const getOpenCommentsCountForStep = async (
  applicationId,
  step,
  accessToken
) => {
  if (applicationId === "00000000-0000-0000-0000-000000000000") return 0;
  try {
    if (debug)
      logger.log(
        "Pobieranie ilości komentarzy dla kroku [" +
          step +
          "] wniosku [" +
          applicationId +
          "]"
      );
    const response = await axios.post(
      ApiHost + `/application/get_open_comments_count`,
      {
        id: applicationId,
        step: step,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    if (response.status === 200) {
      let count = response.data.OpenCommentCount;
      return count;
    }
    return 0;
  } catch (error) {
    logger.error(
      "Błąd podczas pobierania ilości komentarzy dla kroku wniosku: ",
      error
    );
  }
};

const removePaymentConfirmation = async (applicationId, accessToken) => {
  try {
    const response = await axios.post(
      ApiHost + `/application/remove_payment_confirmation`,
      {
        application_id: applicationId,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
  } catch (error) {
    logger.error("Błąd podczas aktualizacji danych wniosku: ", error);
  }
};

const updateApplicationContent = async (
  id,
  appContent,
  userIdOrAccessToken,
  maybeAccessToken
) => {
  try {
    const accessToken = maybeAccessToken || userIdOrAccessToken;
    if (!accessToken) {
      logger.error(
        "Brak accessToken podczas aktualizacji danych wniosku [" + id + "]",
      );
      return;
    }

    if (debug) logger.log("Aktualizacja danych wniosku [" + id + "]");
    const response = await axios.post(
      ApiHost + `/application/update`,
      {
        id: id,
        content: appContent,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    if (response.status === 200) {
      let newId = response.data.id;
      if (debug) logger.log("Zaktualizowano dane wniosku [" + id + "]");
    }
  } catch (error) {
    logger.error("Błąd podczas aktualizacji danych wniosku: ", error);
  }
};

const addMessage = async (
  applicationId,
  step,
  commentId,
  message,
  accessToken
) => {
  try {
    if (debug)
      logger.log(
        "Dodawanie wiadomości do wniosku [" + applicationId + "|" + step + "]"
      );
    const response = await axios.post(
      ApiHost + `/application/append_message`,
      {
        id: applicationId,
        step: step,
        comment_id: commentId,
        message: message,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    logger.error("Błąd podczas dodawania wiadomości do wniosku: ", error);
    throw error;
  }
};

const setConversationStatus = async (
  applicationId,
  step,
  commentId,
  status,
  accessToken
) => {
  try {
    if (debug)
      logger.log(
        "Ustawianie statusu komentarza [" +
          applicationId +
          "|" +
          step +
          "|" +
          commentId +
          "]"
      );
    const response = await axios.post(
      ApiHost + `/application/set_conversation_status`,
      {
        id: applicationId,
        step: step,
        comment_id: commentId,
        status: status,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    if (response.status === 200) {
      if (debug)
        logger.log(
          "Zaktualizowano status rozmowy wniosku [" + applicationId + "]"
        );
    }
  } catch (error) {
    logger.error("Błąd podczas aktualizacji statusu rozmowy wniosku: ", error);
  }
};

const getApplicationStatus = async (id, role, accessToken) => {
  if (id === "00000000-0000-0000-0000-000000000000") return "Nieznany";
  try {
    if (debug) logger.log("Pobieranie statusu wniosku [" + id + "]");
    const response = await axios.post(
      ApiHost + `/application/get_status`,
      {
        id: id,
        role: role,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    if (response.status === 200) {
      let status = response.data;
      if (debug) logger.log("Status: " + status);
      return status;
    }
    return "Nieznany";
  } catch (error) {
    logger.error("Błąd podczas aktualizacji danych wniosku: ", error);
  }
};

const assignChamber = async (id, chamberId, accessToken) => {
  try {
    if (debug) logger.log("Przypisanie izby do wniosku [" + id + "]");
    const response = await axios.post(
      ApiHost + `/application/assign_chamber`,
      {
        id: id,
        chamberid: chamberId,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    if (response.status === 200) {
      let result = response.data;
      if (debug) logger.log("assignChamber Result: " + result);
      return result;
    }
    return "false";
  } catch (error) {
    logger.error("Błąd podczas przypisywania izby do wniosku: ", error);
  }
};

const assignUser = async (id, userId, accessToken) => {
  try {
    if (debug) logger.log("Przypisanie użytkownika do wniosku [" + id + "]");
    const response = await axios.post(
      ApiHost + `/application/assign_user`,
      {
        id: id,
        userid: userId,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    if (response.status === 200) {
      let result = response.data;
      if (debug) logger.log("assignUser Result: " + result);
      return result;
    }
    return "false";
  } catch (error) {
    logger.error("Błąd podczas przypisywania użytkownika do wniosku: ", error);
  }
};

const assignOldestApplication = async (userId, accessToken) => {
  try {
    if (debug)
      logger.log(
        "Przypisanie najstarszego wniosku z izby użytkownika [" + userId + "]"
      );
    const response = await axios.post(
      ApiHost + `/application/assign_oldest_application`,
      {
        user_id: userId,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    if (response.status === 200) {
      let result = response.data;
      if (debug) logger.log("assignOldestApplication Result: " + result);
      return result;
    }
    return "false";
  } catch (error) {
    logger.error("Błąd podczas przypisywania najstarszego wniosku: ", error);
  }
};

const appendSignedApplication = async (
  id,
  signedFileId,
  signedFileName,
  accessToken
) => {
  try {
    if (debug) logger.log("Dodawanie podpisanego wniosku [" + id + "]");
    const response = await axios.post(
      ApiHost + `/application/append_signed_application`,
      {
        id: id,
        signedFileId: signedFileId,
        signedFileName: signedFileName,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    if (response.status === 200) {
      let result = response.data;
      if (debug) logger.log("appendSignedApplication Result: " + result);
      return result;
    }
    return "false";
  } catch (error) {
    logger.error("Błąd podczas dodawania podpisanego wniosku: ", error);
  }
};

const appendPaymentConfirmation = async (
  id,
  paymentFileId,
  paymentFileName,
  amountGross,
  accessToken
) => {
  try {
    if (debug) logger.log("Dodawanie potwierdzenia opłaty [" + id + "]");
    const response = await axios.post(
      ApiHost + `/application/append_payment_confirmation`,
      {
        id: id,
        paymentFileId: paymentFileId,
        paymentFileName: paymentFileName,
        amount: amountGross,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    if (response.status === 200) {
      let result = response.data;
      if (debug) logger.log("appendPaymentConfirmation Result: " + result);
      return result;
    }
    return "false";
  } catch (error) {
    logger.error("Błąd podczas dodawania potwierdzenia opłaty: ", error);
  }
};

const appendInvoice = async (
  id,
  invoiceFileId,
  invoiceFileName,
  accessToken
) => {
  try {
    if (debug) logger.log("Dodawanie faktury [" + id + "]");
    const response = await axios.post(
      ApiHost + `/application/append_invoice`,
      {
        id: id,
        invoiceFileId: invoiceFileId,
        invoiceFileName: invoiceFileName,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    if (response.status === 200) {
      let result = response.data;
      if (debug) logger.log("appendInvoice Result: " + result);
      return result;
    }
    return "false";
  } catch (error) {
    logger.error("Błąd podczas dodawania faktury: ", error);
  }
};

const updateAttachments = async (id, attachments, accessToken) => {
  try {
    if (debug) logger.log("Aktualizacja załączników wniosku [" + id + "]");
    const response = await axios.post(
      ApiHost + `/application/update_attachments`,
      {
        id: id,
        attachments: attachments,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    if (response.status === 200) {
      let result = response.data;
      if (debug) logger.log("updateAttachments Result: " + result);
      return result;
    }
    return "false";
  } catch (error) {
    logger.error("Błąd podczas aktualizacji załączników wniosku: ", error);
  }
};

const revokeApplication = async (id, accessToken) => {
  try {
    if (debug) logger.log("Wycofanie wniosku [" + id + "]");
    const response = await axios.post(
      ApiHost + `/application/revoke`,
      {
        id: id,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    if (response.status === 200) {
      if (debug) logger.log("Wycofano wniosek [" + id + "]");
      return true;
    }
    return false;
  } catch (error) {
    logger.error("Błąd podczas wycofywania wniosku: ", error);
  }
};


const prepareProductsImport = async (file, accessToken) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    const response = await axios.post(
      ApiHost + `/application/prepare_import`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    if (response.status === 200) {
      return response.data;
    }
    return null;
  } catch (error) {
    logger.error("Błąd podczas importu produktów z pliku XLSX:", error);
    return null;
  }
};

const checkAccess = async (id, accessToken) => {
  try {
    const response = await axios.post(
      ApiHost + `/application/check_access`,
      {
        id: id,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    if (response.status === 200) {
      return true;
    }
    return false;
  } catch (error) {
    logger.error("Błąd podczas sprawdzania dostępu: ", error);
  }
};

/**
 * Dodaje notatkę do wniosku (backend wyciąga user_id z JWT).
 * @param {string} applicationId ‒ UUID wniosku
 * @param {string} text ‒ treść notatki
 * @param {string} userId ‒ Id użytkownika
 * @param {string} accessToken ‒ token
 * @returns {object|null} ‒ obiekt dodanej notatki lub null w wypadku błędu
 */
const addNote = async (applicationId, userId, text, accessToken) => {
  try {
    if (debug)
      logger.log(`Dodawanie notatki do wniosku [${applicationId}]: ${text}`);
    const response = await axios.post(
      ApiHost + `/application/add_note`,
      { id: applicationId, text, user_id: userId },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    );
    if (response.status === 200) {
      if (debug) logger.log("Dodano notatkę:", response.data.note);
      return response.data.note;
    }
    return null;
  } catch (error) {
    logger.error("Błąd podczas dodawania notatki:", error);
    return null;
  }
};

/**
 * Pobiera notatki aktualnie zalogowanego usera do danego wniosku.
 * @param {string} applicationId ‒ UUID wniosku
 * @param {string} userId ‒ Id użytkownika
 * @param {string} accessToken ‒ token JWT
 * @returns {Array<object>} ‒ lista notatek
 */
const getNotes = async (applicationId, userId, accessToken) => {
  try {
    if (debug) logger.log(`Pobieranie notatek dla wniosku [${applicationId}]`);
    const response = await axios.post(
      ApiHost + `/application/get_notes`,
      { id: applicationId, user_id: userId },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    );
    if (response.status === 200) {
      if (debug) logger.log("Notatki:", response.data.notes);
      return response.data.notes;
    }
    return [];
  } catch (error) {
    logger.error("Błąd podczas pobierania notatek:", error);
    return [];
  }
};

// Dodaj te funkcje do swojego pliku services/Application.js

/**
 * Pobiera liczbę odpowiedzianych komentarzy dla każdego kroku aplikacji
 * @param {string} applicationId - ID aplikacji
 * @param {string} accessToken - Token dostępu
 * @returns {Promise<Array<number>>} - Tablica z liczbą odpowiedzianych komentarzy dla każdego kroku
 */
const getAnsweredCommentCounts = async (applicationId, accessToken) => {
  if (applicationId === "00000000-0000-0000-0000-000000000000") {
    return [0, 0, 0, 0, 0];
  }

  try {
    const response = await axios.post(
      ApiHost + `/application/get_answered_comment_counts`,
      {
        id: applicationId,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    if (response.status === 200) {
      return response.data.AnsweredCommentCounts || [0, 0, 0, 0, 0];
    }

    return [0, 0, 0, 0, 0];
  } catch (error) {
    logger.error("Error fetching answered comment counts:", error);
    return [0, 0, 0, 0, 0];
  }
};

/**
 * Ustawia status konwersacji na "answered" (odpowiedziane)
 * @param {string} applicationId - ID aplikacji
 * @param {string} step - Numer kroku
 * @param {string} conversationId - ID konwersacji
 * @param {string} accessToken - Token dostępu
 * @returns {Promise<Object>} - Response z serwera
 */
const setConversationAnswered = async (
  applicationId,
  step,
  conversationId,
  accessToken
) => {
  try {
    const response = await axios.post(
      ApiHost + `/application/set_conversation_status`,
      {
        id: applicationId,
        step,
        comment_id: conversationId,
        status: "answered",
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    if (response.status !== 200) {
      throw new Error("Failed to set conversation as answered");
    }

    return response.data;
  } catch (error) {
    logger.error("Error setting conversation as answered:", error);
    throw error;
  }
};

export {
  getAnsweredCommentCounts,
  setConversationAnswered,
  removePaymentConfirmation,
  addNote,
  getNotes,
  addApplication,
  addMessage,
  appendInvoice,
  appendPaymentConfirmation,
  appendSignedApplication,
  assignChamber,
  assignOldestApplication,
  assignUser,
  checkAccess,
  copyApplication,
  createEmptyApplication,
  createEmptyFileData,
  createEmptyFileConnection,
  createEmptyProductData,
  createEmptyProductComponent,
  createEmptyProcessData,
  createEmptyProductDetails,
  createEmptyStep3,
  createEmptyStep5,
  createEmptySummary,
  deleteApplication,
  getApplicationContent,
  getApplicationComment,
  getOpenCommentsCountForStep,
  getOpenCommentCounts,
  getApplicationMetadata,
  getApplicationStatus,
  getPreviousVersionContent,
  getSignedApplication,
  prepareProductsImport,
  revokeApplication,
  setConversationStatus,
  updateApplicationContent,
  updateAttachments,
  generateGUID,
};


